// user action types
export const AUTHENTICATE_USER = 'AUTHENTICATE_USER'
export const SET_USER_INFO = 'SET_USER_INFO'
export const LOGOUT_USER = 'LOGOUT_USER'

// merchant actions
export const SET_MERCHANT = 'SET_MERCHANT'
